import { useState, useEffect } from "react";
import { KTSVG } from "../../../helpers/KTSVG";
import { useDebounce } from "../../../hooks/useDebounce";
import useTableCtx from "../tableContext/useTableCtx";

const TableSearch = ({
  value,
  withSearch,
}: {
  value: string;
  withSearch?:
    | boolean
    | {
        placeholder?: string;
        withoutSearchIcon?: boolean;
        withoutSearchClear?: boolean;
        searchDelay?: number;
      };
}) => {
  const { placeholder, withoutSearchIcon, withoutSearchClear, searchDelay } =
    withSearch as {
      placeholder?: string;
      withoutSearchIcon?: boolean;
      withoutSearchClear?: boolean;
      searchDelay?: number;
    };
  const { tableSearch, handleTableSearch } = useTableCtx()!;

  const contextValue = tableSearch?.[value] ?? "";

  const [searchTerm, setSearchTerm] = useState<string>(contextValue);

  const debouncedSearchTerm = useDebounce(searchTerm, searchDelay || 1000);

  useEffect(() => {
    if (contextValue !== searchTerm) {
      setSearchTerm(contextValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && debouncedSearchTerm !== null) {
      handleTableSearch(value, debouncedSearchTerm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchTerm]);

  return (
    <div>
      <div className="d-flex align-items-center position-relative">
        {!withoutSearchIcon && (
          <KTSVG
            path="/media/icons/duotune/general/gen021.svg"
            className="svg-icon-1 position-absolute ms-2"
          />
        )}
        <input
          type="text"
          data-kt-user-table-filter="search"
          className={`form-control form-control-solid bg-white py-2 ${
            withoutSearchIcon ? "ps-4" : "ps-9"
          }`}
          placeholder={placeholder}
          value={searchTerm || ""}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        {searchTerm && searchTerm.length > 0 && !withoutSearchClear && (
          <button
            className="position-absolute end-0 cursor-pointer btn btn-icon rounded-circle"
            onClick={() => setSearchTerm("")}>
            <KTSVG
              path="/media/icons/duotune/general/gen040.svg"
              className="svg-icon-1"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export { TableSearch };
